import React from 'react';
import { GridCell } from '../../../../../../../common/components/Grid/Grid';
import { TopDialogue } from '@mm/state/interfaces/botAnalytics';

type CellProps = {
  item: TopDialogue;
  orderNumber?: number;
};

export const renderDialogueNameCell = (props: CellProps) => {
  const { item, orderNumber } = props;
  return (
    <GridCell className="top-dialogues-grid__cell-dialogue-name-container">
      <span>
        {orderNumber}.{' '}
        <span className="top-dialogues-grid__cell-dialogue-name">
          {item.folder}: {item.name}
        </span>
      </span>
    </GridCell>
  );
};

export const renderContactsReachedAmountCell = (props: CellProps) => {
  const { item } = props;
  return (
    <GridCell>
      <span>{item.viewsCount}</span>
    </GridCell>
  );
};

export const renderSentAmountCell = (props: CellProps) => {
  const { item } = props;
  return (
    <GridCell>
      <span>{item.notUniqViewsCount}</span>
    </GridCell>
  );
};

export const renderConversationSessionsCell = (props: CellProps) => {
  const { item } = props;
  return (
    <GridCell>
      <span>{item.sessionsStartedCount}</span>
    </GridCell>
  );
};

export const renderRespondedCell = (props: CellProps) => {
  const { item } = props;
  return (
    <GridCell>
      <span>{item.notUniqResponsesCount}</span>
    </GridCell>
  );
};

export const renderResponseRateCell = (props: CellProps) => {
  const { item } = props;
  const { notUniqResponsesCount, notUniqViewsCount } = item;
  const responseRate =
    notUniqResponsesCount && notUniqViewsCount
      ? ((notUniqResponsesCount / notUniqViewsCount) * 100).toFixed(1)
      : 0;
  return (
    <GridCell>
      <span>{responseRate}%</span>
    </GridCell>
  );
};
